import axios from "axios";

const DEFAULT_API_BASE_URL = "https://sakhisshop.com";
const envApiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const API_BASE_URL = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?/i.test(
  envApiBaseUrl || "",
)
  ? DEFAULT_API_BASE_URL
  : envApiBaseUrl || DEFAULT_API_BASE_URL;

const client = axios.create({
  baseURL: `${API_BASE_URL}/api/label`,
});

// ---- Categories ----
export const getCategories = () =>
  client.get("/categories").then((r) => r.data);
export const createCategory = (payload) =>
  client.post("/categories", payload).then((r) => r.data);
export const updateCategory = (id, payload) =>
  client.put(`/categories/${id}`, payload).then((r) => r.data);
export const deleteCategory = (id) =>
  client.delete(`/categories/${id}`).then((r) => r.data);

// ---- Products ----
export const getProducts = () => client.get("/products").then((r) => r.data);
export const getProduct = (id) =>
  client.get(`/products/${id}`).then((r) => r.data);
export const createProduct = (payload) =>
  client.post("/products", payload).then((r) => r.data);
export const updateProduct = (id, payload) =>
  client.put(`/products/${id}`, payload).then((r) => r.data);
export const deleteProduct = (id) =>
  client.delete(`/products/${id}`).then((r) => r.data);

// ---- Templates ----
export const getTemplates = () => client.get("/templates").then((r) => r.data);
export const getTemplate = (id) =>
  client.get(`/templates/${id}`).then((r) => r.data);
export const createTemplate = (payload) =>
  client.post("/templates", payload).then((r) => r.data);
export const updateTemplate = (id, payload) =>
  client.put(`/templates/${id}`, payload).then((r) => r.data);
export const deleteTemplate = (id) =>
  client.delete(`/templates/${id}`).then((r) => r.data);

// ---- Label Generation ----
export const resolvePlaceholders = (params) =>
  client.get("/resolve", { params }).then((r) => r.data);
export const generateLabel = (payload) =>
  client.post("/generate", payload).then((r) => r.data);
export const getLabelHistory = (productId) =>
  client
    .get("/history", { params: productId ? { productId } : {} })
    .then((r) => r.data);
export const recordPrint = (payload) =>
  client.post("/print", payload).then((r) => r.data);
export const getPrintHistory = () =>
  client.get("/print-history").then((r) => r.data);

export default client;
